export function SplashLoader() {
  return (
    <div
      role="status"
      aria-label="Loading"
      data-testid="splash-loader"
      className="grid h-screen place-items-center bg-background"
    >
      <span aria-hidden="true" className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
    </div>
  );
}
